var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.href.length
    ? _c("a", { staticClass: "image lazy-image", attrs: { href: _vm.href } }, [
        _c("img", {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy",
              value: _vm.src,
              expression: "src",
            },
          ],
          attrs: { alt: _vm.alt },
        }),
      ])
    : _c(
        "div",
        { staticClass: "image lazy-image" },
        [
          _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.src,
                expression: "src",
              },
            ],
            attrs: { alt: _vm.alt },
          }),
          _vm._t("default"),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/LazyImage.vue